import type React from 'react';
import type {
    BranchScopeCopy,
    BranchScopeLayout,
    ProductBranchScope,
} from './branchScopeMeta';
import { BranchScopeLine } from './BranchScopeLine';
import { BranchScopePicker } from './BranchScopePicker';

type BranchScopeFieldProps = {
    scope: ProductBranchScope;
    /** The branch the figures count; `null` is All branches. */
    value: string | null;
    onChange: (branchId: string | null) => void;
    copy: BranchScopeCopy;
    layout: BranchScopeLayout;
};

/**
 * Whose stock the figures count, on the filters drawer and the product
 * details page alike (bos-app#138): an OrgAdmin picks the branch, a
 * BranchAdmin sees theirs, and without a session there is nothing here. Each
 * screen gives its own copy and says where it puts the field; the choice
 * goes back as a branch id.
 */
export const BranchScopeField: React.FC<BranchScopeFieldProps> = ({
    scope,
    value,
    onChange,
    copy,
    layout,
}) => {
    switch (scope.mode) {
        case 'pick':
            return (
                <BranchScopePicker
                    copy={copy}
                    layout={layout}
                    onChange={onChange}
                    options={scope.options}
                    value={value}
                />
            );
        case 'fixed':
            return (
                <BranchScopeLine
                    branchName={scope.branchName}
                    copy={copy}
                    layout={layout}
                />
            );
        case 'none':
            return null;
    }
};
